import * as React from 'react';

import './RegularInput.style.css';
import './UnderlineInput.style.css';

export interface TTextInputProps {
  name: string;
  value?: any;
  placeHolder?: string;
  className?: string;
  onChange?: (event: any) => void;
  onBlur?: (event: any) => void;
  onKeyPress?: (event: any) => void;
  showError?: boolean;
  errorText?: string;
  type?: string;
  disabled?: boolean;
  hideErrorText?: boolean;
  maxLength?: number;
}

export const TextInput: React.StatelessComponent<TTextInputProps> = ({
  name,
  value,
  placeHolder,
  className,
  onChange,
  onBlur,
  showError,
  errorText,
  type,
  disabled,
  onKeyPress,
  hideErrorText,
  maxLength,
}) => {
  let typeClass = 'regular-input';

  if (type) {
    switch (type) {
      case 'underline':
        typeClass = 'underline-input';
        break;
      case 'regular':
      default:
        typeClass = 'regular-input';
        break;
    }
  }

  if (className) {
    className += ` ${typeClass}`;
  } else {
    className = typeClass;
  }

  const validationFailed = showError && errorText && errorText.length > 0;

  if (validationFailed === true) {
    className += ' validation-error';
  }
  return (
    <div className="input-container">
      <input
        type={type}
        className={className}
        placeholder={placeHolder}
        value={value != null ? value : ''}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        onKeyPress={onKeyPress}
        maxLength={maxLength}
      />
      {validationFailed && !hideErrorText && (
        <div className="validation-error text">{errorText}</div>
      )}
    </div>
  );
};
